export default {
  //我的
  'user.login.register': 'Login / Sign up',
  'user.item1': 'Help',
  'user.item2': 'General',
  'user.item3': 'Security settings',
  'user.item4': 'About Us',
  'user.item5': 'Contact us',
  'user.logout': 'Log out',
  'user.index.mine': 'Mine',
  'user.index.assets': 'Assets',

  //关于我们
  'footer.contact.item1': 'Service WeChat：',
  'footer.contact.item2': 'Business Coop：',
  'user.aboutUs.title': 'About us',
  'user.aboutUs.desc1': 'WBroker was established in 2017 as a financial services provider registered in New Zealand. The company holds broker licenses such as the Australian ASIC license and the New Zealand FSPR license, and is committed to providing investment services such as stock trading and financing to clients worldwide.',
  'user.aboutUs.desc2': 'Our top priority is to secure your assets and minimize investment risk. WBroker provides the most Simple, Safe, and Reliable financial services to global clients.',
  'user.aboutUs.desc3': 'WBroker stands with minority groups and embraces all humans. We promote gender equality and help women and kids in impoverished areas. We strive to create a community where everyone has equal access to financial benefits.',

  //错误吗
  'error.999991': 'Incorrect parameters',
  'user.tryAgainLater': 'Try Later',
  'user.accountExist': 'This account exists',
  'user.codeError': 'Incorrect verification code',
  'user.amountMoreRate': 'Withdrawal amount should exceed commission fee',
  'user.assetNotEnough': 'Inadequate cash',
  'user.code039992': "Can't withdraw with existing purchase application.",
  'user.code039993': 'Unsettled withdrawal exists. Try later',
  'user.code039994': 'Failed to capture asset',
  'user.code019111': 'Photo side is blurred. Upload again',
  'user.code019112': 'Emblem side is blurred. Upload again',
  'user.code019115': 'Picture is blurred. Fill in the info by hand',
  'user.code019116': "Picture doesn't match",
  'user.code170001': 'This is currently unavailable',
  'user.code170002': 'Your subscription is below the minimum requirement',
  'user.code170004': 'This is currently unredeemable',
  'user.code170005': 'Inadequate position',
  'user.code170006': "New IPO exists. This can't be subscribed or redeemed",
  'user.code199921': 'This operation is not allowed under your existing trust',
  'user.code019991': 'Incorrect verification code',
  'user.code019992': 'Incorrect verification code',
  'user.code009995': 'This email is occupied',
  'user.code009991': "The account doesn't exist",
  'user.code009992': 'Incorrect password',
  'user.code009993': 'This account is already in use',
  'user.code019990': 'Failed to send message',
  'user.code029992': '对手订单已被抢购',
  'user.code009997': "Name doesn't match ID card",
  'user.code009998': 'The ID card is already in use',
  'user.code019999': 'This account exists',
  'user.code020002': "You can't open account at your age",
  'user.code020003': 'Unidentifiable ID. Contact service team for help',
  'user.code019119': 'Your ID card has expired',
  'user.code019120': 'Your certificate has expired',
  'user.code020011': "Filled info doesn't match the info in the picture",
  'user.code009980': 'Email address of this domain is not supported, try another one',
  'user.code019130': 'Your account has been suspended',
  'user.code010002': 'Unsettled loan exists',
  'user.code010001': 'Loan error. Contact service team',
  'user.code039777': 'Rejections exceed daily limit',
  'user.code023010': 'Payment failed',
  'user.code577220398': 'Your margin IPO subscription failed for our financing amount ran out.',
  'message.error.199678': 'Link to invitation has expired',
  'message.error.199668': 'Invitation code is incorrect',
  'message.error.199679': 'Invitation code already exists',
  'message.error.199669': 'Do not fill in the invitation code for users who register later than you.',
  'setting.email.error': 'E-mail address parameter error',
  'setting.email.code.error': 'Wrong verification code for the current e-mail address',
  'setting.new.email.error': 'Wrong verification code for the new e-mail address',
  'setting.mobile.error': 'Phone parameter error',
  'setting.mobile.code.error': 'Wrong verification code for the current phone',
  'setting.new.mobile.error': 'Wrong verification code for the new phone',
  'setting.txPassword.error': 'Incorrect transaction PIN',
  'setting.new.txPassword.error': 'The transaction PIN cannot be the same as the current transaction PIN',
  'setting.password.error': 'Wrong login password',
  'setting.new.password.error': 'The login password cannot be the same as the previous three change records',
  'setting.face.error': 'Wrong face recognition',
  'setting.error039930': 'Fail to obtain security verification settings',
  'setting.error039931': 'Wrong e-mail verification code',
  'setting.error039932': 'Wrong phone verification code',
  'setting.error039935': 'Wrong phone number or e-mail address',
  'message.error.030061': '手机已被绑定，请修改手机后重新操作',
  'message.error.030060': '邮箱已被绑定，请修改邮箱后重新操作',
  'user.TransactionPasswordError': 'Incorrect transaction PIN',
  'message.error.7020': '帐户不存在',

  //个人中心
  'user.personalInformation': 'Bind Phone',
  'user.personalInformation2': 'Bind Email',
  'user.uploadInfo.personalInformation': 'Personal Information',
  'user.userInfo.title': 'Account',
  'user.name': 'Name',
  'user.certificateType': 'Certificate',
  'user.mainlandID': 'CHN Mainland ID',
  'user.passport': 'Passport',
  'user.hongKongID': 'HK ID',
  'user.otherID': 'Other ID',
  'user.idNumber': 'No.',
  'user.customerNo': 'UID',
  'user.accountStatus': 'Status',
  'user.hasNotOpenAccount': 'Unregistered',
  'user.accountApproving': 'Pending',
  'user.hasOpen': 'Registered',
  'user.frozen': 'Frozen',
  'user.rejectApprove': 'Application rejected',
  'user.accountCancellation': 'Canceled',
  'user.inactivated': 'Inactivated',
  'user.unknownStatus': 'Unknow',

  //帮助中心
  'helpCenter.header': 'Welcome to Help Center',
  'user.help.search': 'Search',
  'help.search.result1': 'About ',
  'help.search.result2': ' results of "',
  'help.search.result3': '"',
  //搜索到与“${XXX}“相关结果共${5}条
  'user.help.desc': 'If the following answers cannot help you, you can contact ',
  'user.help.desc.onlineServer': 'Customer Service',
  'user.help.desc.last': ' ',
  //如果下列回答不能帮助到您, 您可以联系在线客服
  'user.help.more': 'More',
  'help.relate.title': 'Related Articles',

  //通用设置
  'user.language': 'Language',
  'user.english': 'English',
  'user.simplifiedChinese': 'Chinese',
  'user.upDownColor': 'Preference',
  'user.upRedDownGreen': 'Red↑Green↓',
  'user.upGreenDownRed': 'Red↓Green↑',

  //安全设置
  'user.modifyLoginPassword': 'Modify Login Password',
  'user.change.trcPsw': 'Modify Transaction PIN',
  'user.email': 'Email',
  'user.mobile': 'Mobile',
  'user.change.withdraw': 'Withdraw Management',
  'setting.go.to.bind': 'Bind',
  'user.ok': 'Confirm',
  'user.verifyMobile': 'Current phone number',
  'user.form.mobileCodeHash.placeholder': 'Enter SMS code',
  'user.getVerifyCode': 'Send',
  'user.verifyEmail': 'Current email address',
  'user.emailCodeHash.placeholder': 'Enter email verification code',
  'user.transactionPassword': 'Transaction PIN',
  'user.finishTransactionPsw': 'Enter transaction PIN',
  'user.loginPsw.label': 'Login password',
  'user.loginPsw.placeholder': 'Please enter login password',
  'user.new.bind.phone': 'Your phone number',
  'user.new.bind.phone.placeholder': 'Please enter the phone number',
  'user.verifyCode': 'Code',
  'user.pleaseFinishVerifyCode': 'Enter verification code',
  'user.new.bind.email': 'Your email address',
  'user.new.bind.email.placeholder': 'Please enter the email address ',
  'user.current.loginPsw': 'Current login password',
  'user.current.loginPsw.placeholder': 'Please enter current login password',
  'user.new.loginPsw': 'New login password',
  'user.new.loginPsw.placeholder': 'Enter 8-12 digit alphanumeric password',
  'user.repeat.new.loginPsw': 'Enter password again',
  'user.new.trans.psw': 'Enter 6-digit PIN',
  'user.new.trans.psw.again': 'Enter 6-digit PIN again',
  'user.new.txPsw': '6-digit number',
  'user.emailRuleError': 'Incorrect email format',
  'user.new.trans.psw.conform': 'Enter 6-digit PIN again',
  'newSetting.mobile.tip1': '*Please note that you are modifying the phone number, and you can withdraw funds only after ',
  'newSetting.mobile.tip1.1': ' hours of modification.',
  'newSetting.mobile.tip2': '*After modification, you will use the new bound phone number to login and retrieve the password.',
  'newSetting.bindMobile.tip1': '*Please note that you are binding the phone number, and you can withdraw funds only after ',
  'newSetting.bindMobile.tip1.1': ' hours of binding.',
  'newSetting.email.tip1': '*Please note that you are modifying the e-mail address, and you can withdraw funds only after ',
  'newSetting.email.tip1.1': ' hours of modification.',
  'newSetting.email.tip2': '*After modification, you will use the new bound e-mail address to login and retrieve the password.',
  'newSetting.bindEmail.tip1': '*Please note that you are binding the e-mail address, and you can withdraw funds only after ',
  'newSetting.bindEmail.tip1.1': ' hours of binding.',
  'newSetting.password.tip1': '*Please note that you are modifying the login password.',
  'newSetting.txPassword.tip1': '*Please note that you are modifying the transaction PIN, and you can withdraw funds only after ',
  'newSetting.txPassword.tip1.1': ' hours of modification.',
  'newSetting.txPassword.tip2': '*Please keep this PIN in mind, transaction and fund related activities that affect the security of the account will be needed to verify the transaction PIN.',
  'newSetting.tip1': "*If you can't receive the verification code or forget the information, please contact ",
  'newSetting.tip2': "Customer Service",
  'newSetting.tip3': " .",
  'user.withdraw.management': 'Withdraw Management',
  'user.withdraw.address.auth': 'Verify address',
  'asset.chainType4': 'TRC20 (TRON)',
  'asset.chainType1': 'ERC20 (ETH)',
  'asset.chainType2': 'OMNI (BTC)',
  'withdraw.address.remark': 'Memo：',
  'withdraw.address.modify': 'Modify',
  'withdraw.address.unBind': 'Unbind',
  'withdraw.bind.address': '+Bind Withdraw Address',
  'confirm.unBind.tip1': 'Unbind will remove it from the list, are you sure?',
  'bindAddress.button2': 'Verify',
  'asset.currency': 'Currency',
  'user.bindAddress.chainType': 'Protocal Type',
  'bindAddress.address.label': 'USDT address',
  'bindAddress.address.placeholder': 'Enter address',
  'bindAddress.address.error': 'Incorrect address format',
  'bindAddress.remark': 'Note',
  'bindAddress.remark.placeholder': 'Optional',
  'bindAddress.password': 'Transaction PIN',
  'user.form.mobileCodeHash': 'SMS code',
  'user.emailCodeHash': 'Email verification code',
  'withdraww.bindAddess.tip1': '*Please note that you are modifying the withdraw address, and you can withdraw funds only after ',
  'withdraww.bindAddess.tip1.1': ' hours of modification.',
  'user.hasModifyLoginPsw': 'Login password is modified',
  'user.hasModifyTransactionPsw': 'Transaction PIN is modified',
  'user.hasModifyEmail': 'Email is modified',
  'user.hasBindEmail': 'Success!',
  'user.hasBindMobile': 'Success!',
  'user.hasModifyMobile': 'Mobile is modified',
  'user.back': 'Back',
  'user.modifyMobile': 'Modify Phone Number',
  'user.modifyEmail': 'Modify Email Address',
  'user.bandEmail': 'Link to email',
  'user.bind.phone': 'Bind Phone Number',
  'user.bind.address.title': 'Bind Withdraw Address',
  'user.bind.address.success': 'Success',

  //联系我们
  'user.contact.title': 'Add our WeChat and enjoy exclusive services',
  'user.contact.save': 'Save',
  'user.contact1': 'CS Wechat 1:',
  'user.contact2': 'CS Wechat 2:',
  'user.contact.email': 'Customer Service:',
  'user.contact.mobile': 'CS Mobile:',
  'user.contactUsTips': 'Business hours: GMT+8  8:30 to 18:30 on business days. Live chat support is available on the App.',

  //登陆注册
  'user.getVerifyCodeFirst': 'Send verification code',
  'user.login': 'Login',
  'user.pleaseFinishPhoneNumber': 'Enter mobile number',
  'user.pleaseFinishEmail': 'Enter email',
  'user.forgetPassword': 'Forgot Password',
  'user.password': 'Password',
  'user.password.placeholder': 'Enter Password',
  'user.no.account.tip1': '',
  'user.no.account.tip2': 'Sign up',
  'user.form.login.email': 'Email Login',
  'user.form.login.mobile': 'Mobile Login',
  'login.tip1': 'By registering or logging in, you have read and agree to the ',
  'login.tip2': 'Terms of Use',
  'login.tip3': ' and ',
  'login.tip4': 'Privacy Policy',
  'user.sign.up': 'Sign up',
  'user.nextStep': 'Next',
  'user.form.register.mobile': 'Mobile Sign up',
  'user.form.register.email': 'Email Sign up',
  'user.has.account.tip1': 'I already have a ',
  'user.has.account.tip2': 'Login',
  'message.send.code.success': 'Success',
  'login.password.format.placeholder': '8-12 digit, letter+number',
  'user.new.loginPsw.tip1': '8-12 digit',
  'user.new.loginPsw.tip2': 'Include letter',
  'user.new.loginPsw.tip3': 'Include number',

  'form.search.address': 'Select region/calling code',
  'form.search.title': 'Country',
  'form.search.input': 'Search',
  'user.cancel': 'Cancel',
  'user.login.authentication': 'Login Authentication',
  'asset.beginTime': 'Open Time',
  'asset.endTime': 'Close Time',
  'asset.finance.page.noData': 'No data',

  'user.emailFind': 'Email',
  'user.mobileFind': 'Mobile',
  'forget.verifyEmail': 'Email',
  'forget.verifyMobile': 'Mobile',
  'forget.transactionPassword': 'PIN',
  'forget.new.password': 'New Password',
  'forget.confirm.password': 'Confirm',

  'face.liveFace': 'Face recognition',
  'face.click.camera': 'Press camera icon for face recognition',
  'face.check.success': 'Face recognition success!',
  'face.check.fail': 'Face recognition failed',
  'face.action0': 'Blink',
  'face.action4': '抬头',
  'face.action5': '低头',
  'face.action7': 'Turn',
  'face.errer.tips': '活体未通过,已刷新动作，请重新录制视频',
  'face.ation.title': 'Identity Verification',
  'face.ation.second.title': 'Please follow the instructions below',
  'face.first.ation': 'Action 1 ',
  'face.second.ation': 'Action 2 ',
  'face.ation.refresh': 'Refresh',
  'face.ation.tip.title': 'Reminder:',
  'face.ation.tip1': 'Keep the environment quiet and well-lit',
  'face.ation.tip2': 'Keep face clear and complete',
  'face.ation.tip3': 'Perform the actions in the required order',
  'face.ation.tip4': 'Record 3-5 seconds',
  'face.ation.btn': 'Start Recording',
  'face.ation.btn.end': 'End Recording',
  'face.ation.btn.restart': 'Record again',
  'face.ation.btn.finish': 'Finish',

  'notification.title': 'News',
  'noMore.data': 'No more data',

  //开户
  'v3.menu.share.open.add.info': 'Open Account',
  'form.account.address.title': 'Select country/region',
  'form.account.type': 'ID Type',
  'form.account.type1': 'China Mainland',
  'form.account.type2': 'HK',
  'trs.first.passport': 'Passport',
  'form.account.type9': 'Identity Certificate',
  'account.open.has.idNumber': 'The ID is already in use',
  'form.account.name.upload.click.front': 'Image Side',
  'form.account.name.upload.click.back': 'Emblem Side',
  'form.account.phone.tip': 'Camera Tips',
  'menu.name.zh.cn': 'Name(CN)',
  'menu.name.zh.placeholder': 'Please enter full name',
  'menu.name.zh.first': 'Surname',
  'menu.name.zh.first.placeholder': 'Example: Cheung',
  'menu.name.zh.second': 'First name (English)',
  'menu.name.zh.second.placeholder': 'Example: John',
  'form.asset.withdraw.placeholder.input': 'Input',
  'user.country': 'Nationality',
  'user.tax.country': 'Region of tax return',
  'user.birthday': 'Date of birth',
  'user.birthday.placeholder': 'Please select date of birth',
  'user.date.choose': 'Please choose a date',
  'user.experied.date': 'Expiration date',
  'user.experied.placeholder': 'Expiration date',
  'user.experied.long.term': 'Valid in long term',
  'form.user.safe.name.prefix.card.number': 'ID No.',
  'form.user.safe.name.placeholder.input.id': 'Enter ID number',
  'account.real.name.explain.first': '1. Under relevant regulations, you are required to fill in necessary information. You can start investing after passing investor assessment.',
  'account.real.name.explain.two': '2. You need to consider your investment goal and risk tolerance before investing in financial products with potential risk.',
  'face.finish.tip': 'Please finish Face recognition',
  'v3.menu.share.open.title': 'Open Account',
  'form.account.openMarket.title': 'I open account to trade',
  'form.stock.hk': 'HK STOCK',
  'form.stock.us': 'US STOCK',
  'form.stock.zht': 'CHINA CONNECT',
  'form.account.risk': 'Risk Disclosure',
  'form.account.risk.standar': 'Licensed representative: ',
  'asset.account.open.audio.txt1': 'Hello, I am , a licensed representative of WBroker. Now I will briefly explain to you some key points in risk disclosure:',
  'asset.account.open.audio.txt2': '1. Investors shall be wary when trading investment products or services that correspond to investment risk preferences and investment needs based on investment experience, investment objectives, income and expenditure, and related conditions. There are risks involved in securities trading. The price may fluctuate, sometimes volatile, and may even become valueless.',
  'asset.account.open.audio.txt3': '2. Trading derivatives involves high risks and it is not suitable for every investor. Investors should note that, generally speaking, the liquidity of derivatives is relatively low, and the price fluctuations are relatively large. They will also be adjusted by the price of the relevant asset or its corporate actions or other factors (such as time value). Derivatives contracts will be more difficult and costly. Certain derivatives have a fixed effective date, and may become worthless after expiration, and there is a risk of forced withdrawal',
  'asset.account.open.audio.txt4': "3. Any individual investor, whether US citizen or permanent resident or not, must pay taxes as long as he/she holds investment products in own name. Those who hold any U.S. security must pay withholding tax on dividends received. Investors should pay attention to the tax issues involved in overseas investments and seek professional tax advice as appropriate. Since the minimum trading unit for US stocks is 1 share, investors should be aware that the trading commission may be higher than the transaction amount. After the order is executed, the investment must pay the relevant commissions and charges. The update notices of the commissions and charges will be published through the company's website or other channels from time to time. U.S. stock trading is strictly regulated by the U.S. Securities Regulatory Commission and not under the supervision of the Hong Kong Securities Regulatory Commission.",
  'asset.account.open.audio.txt5': '4. As a customer, you need to bear the related risks that may arise in electronic transactions. Please read the risk disclosure and complete the account-opening. If you have any question, please feel free to contact us. Thanks!',
  'user.forth.tip1': 'When you click the ',
  'user.forth.tip2': "'I have read'",
  'user.forth.tip3': ' button, it means you have read and understood the risks described above',
  //当您点击${“已阅读”}按钮，表示您已阅读并了解上述风险
  'user.forth.btn': 'I have read',
  'trs.tenth.tip2': 'Please complete the signing of agreement first.',
  'open.account.file.title': 'Contract Signing',
  'open.account.file.desc': 'I have carefully read and agreed to sign all of the following account opening documents',
  'open.account.file.title2': 'Personal Statement',
  'account.open.agrement.check.hkLetter.file': '<Hong Kong Investor Identification Regime (HKIDR) Individual Client Consents>',
  'account.open.agrement.check.customer.file': '<Client Service Agreement>',
  'account.open.agrement.check.risk': '<Risk Disclosure>',
  'account.open.agrement.check.no.usa': '<W-8Ben Tax exemption form for non-Americans>',
  'account.open.agrement.check.commitment': '<Letter of Commitment>',
  'account.open.agrement.check1': 'I am the ultimate and sole beneficiary of this account.',
  'account.open.agrement.check2': 'I have no relationship with the directors and employees of this company.',
  'account.open.agrement.check3': 'I am not a licensee, employee, director, or executive of any exchange, security company, or other financial institution.',
  'account.open.agrement.check4': 'I do not serve as any important public office, such as officer in government agencies, military, or state-owned institutions.',
  'account.open.agrement.check5': 'I am not a U.S. permanent resident (green card holder)',
  'account.open.sign.alert': 'Please complete the signature',
  'account.open.sign.title': 'Signature',
  'account.open.sign.desc': 'Make sure the signature matches the name of account holder.',
  'account.open.sign.reset': 'Eraser',
  'account.open.setPsw.title': 'Set initial transaction PIN',
  'account.open.setPsw.title.confirm': 'Confirm your transaction PIN',
  'account.open.setPsw.tip': 'Enter a six-digit number',
  'account.open.setPsw.error': "Those passwords didn't match. Try again",
  'account.open.setPsw.bottom.tip': '*Please remember your transaction PIN. To ensure the safety of assets, you are required to enter the PIN before each subsequent trade.',
  'stock.approving': 'Your application is under review.',
  'account.open.end.notice1': 'Your application has been submitted.',
  'form.asset.withdraw.placeholder.select': 'Please select',
  'form.account.house.has': 'Own',
  'form.account.house.use': 'Rent',
  'form.account.house.with': 'Live with relatives',
  'form.account.stepGrray1': '< 1 yr',
  'form.account.stepGrray2': '1~3 yrs',
  'form.account.stepGrray3': '3~10 yrs',
  'form.account.stepGrray4': '> 10 yrs',
  'form.account.stepGrrayChildren1': 'Stocks, bonds, and other securities',
  'form.account.stepGrrayChildren2': 'Leveraged foreign exchange',
  'form.account.stepGrrayChildren3': 'Precious metals',
  'form.account.stepGrrayChildren4': 'Futures/Options',
  'form.account.stepHrray1': 'Familiar',
  'form.account.stepHrray2': 'Not familiar',
  'form.account.stepHrrayChildren1': 'trading derivatives',
  'form.account.stepHrrayChildren2': 'taking lessons or training about derivatives',
  'form.account.stepHrrayChildren3': 'related working experience',
  'form.account.choose.houseStatus': 'Please complete the information',
  'form.account.houseStatus.value': 'Enter estimates',
  'form.account.houseStatus.number': 'Please enter value',
  'form.account.work.status': 'Please complete the employment information',
  'form.account.input.work.status': 'Please complete the employment information',
  'form.account.choose.edu': 'Please complete the education information',
  'form.account.choose.asset': 'Please complete the asset information',
  'form.account.choose.income': 'Please complete the income information',
  'form.account.choose.target': 'Please complete the investment information',
  'form.account.choose.experience': 'Please complete the experience information',
  'form.account.choose.experienceType': 'Please complete the experience information',
  'form.account.choose.derivativesKnowledge': 'Please complete the derivatives information',
  'form.account.choose.hasKnowledge': 'Please complete the derivatives information',
  'form.account.choose.riskTolerance': 'If your risk tolerance does not meet regulatory requirements, you will not be able to open account',
  'form.account.houseSituation': 'Housing',
  'form.account.valuation': 'Valuation (net of mortgage)',
  'form.account.valuation.placeholder': 'Enter amount',
  'form.account.work.label1': 'Employed by',
  'form.account.work.label1.placeholder': 'Enter your company name',
  'form.account.work.label2': 'Industry',
  'form.account.work.label2.placeholder': 'Enter the industry',
  'form.account.work.label3': 'Working for',
  'form.account.work.label3.placeholder': 'Enter years',
  'form.account.work.label4': 'Job',
  'form.account.work.label4.placeholder': 'Enter your job',
  'form.account.work.label5': 'Business type',
  'form.account.work.label5.placeholder': 'Enter the business type',
  'form.account.investmentExperience': 'Investment experience',
  'form.account.derivativesKnowledge': 'About derivatives',
  'form.account.derivativesKnowledge0': 'From',
  'form.account.name.prefix.address': 'Address',
  'form.account.name.placeholder.input.address': 'Enter address',
  'account.open.form.work.status': 'Employment status',
  'account.open.form.work.hire': 'Employee',
  'account.open.form.work.hire.self': 'Self-employed',
  'account.open.form.work.other': 'Other',
  'account.open.education.status': 'Education',
  'account.open.education.status.primary': 'Primary or below',
  'account.open.education.status.middle': 'Middle school',
  'account.open.education.status.college': 'Junior college',
  'account.open.education.status.undergraduate': 'Bachelor or above',
  'account.open.asset.status': 'Personal assets',
  'account.open.asset.status30': '< 0.3m',
  'account.open.asset.status100': '0.3m~1m',
  'account.open.asset.status500': '1m~5m',
  'account.open.asset.status.more': '> 5m',
  'account.open.asset.year.status': 'Annual income',
  'account.open.asset.year.status10': '< 0.1m',
  'account.open.asset.year.status30': '0.1m~0.3m',
  'account.open.asset.year.status500': '0.3m~5m',
  'account.open.asset.year.status.more': '> 5m',
  'account.open.invest.target': 'Investment goal',
  'account.open.invest.target.no.lose': 'Breakeven',
  'account.open.invest.target.share': 'Dividend',
  'account.open.invest.target.all': 'Speculation',
  'account.open.invest.experience': 'Investment experience',
  'account.open.invest.experience.no': 'No',
  'account.open.invest.experience.soso': 'Average',
  'account.open.invest.experience.much': 'Rich',
  'account.open.affordability.status': 'Risk tolerance',
  'account.open.taffordability.status.no': 'Zero',
  'account.open.taffordability.status.low': 'Low (5~10% loss)',
  'account.open.taffordability.status.mid': 'Middle (10~20% loss)',
  'account.open.taffordability.status.high': 'High (20%+ loss)',
  'account.open.quit.message': 'Confirm to leave from account opening?',

  'form.user.safe.name.idcard': '身份证',

}
